import { selectSliceCisview } from '../../selectors/HELPERS';
import { ROOT_SLICE } from './constants';
import { getJobLineKey } from './util';

/**
 * SLICES
 */
export const selectRootSlice = state => {
	const appSlice = selectSliceCisview(state);
	return appSlice[ROOT_SLICE] || state;
};


/**
 * BASE
 */

export const selectMapIsChecking = state => {
	const slice = selectRootSlice(state);
	return slice.isChecking;
}

export const selectMapHasChecked = state => {
	const slice = selectRootSlice(state);
	return slice.hasChecked;
}

export const selectMapHasUserData = state => {
	const slice = selectRootSlice(state);
	return slice.hasUserData;
}

export const selectMapErrorMessages = state => {
	const slice = selectRootSlice(state);
	return slice.errorMessages;
}


/**
 * MAIN
 */

export const selectIsChecking = (state, survey) => {
	const jobLineKey = getJobLineKey(survey);
	const _map = selectMapIsChecking(state);
	return _map[jobLineKey];
}

export const selectHasChecked = (state, survey) => {
	const jobLineKey = getJobLineKey(survey);
	const _map = selectMapHasChecked(state);
	return _map[jobLineKey];
}

export const selectHasUserData = (state, survey) => {
	const jobLineKey = getJobLineKey(survey);
	const _map = selectMapHasUserData(state);
	return _map[jobLineKey];
}

export const selectErrorMessages = (state, survey) => {
	const jobLineKey = getJobLineKey(survey);
	const _map = selectMapErrorMessages(state);
	return _map[jobLineKey];
}



export default {
	selectRootSlice,

	selectMapIsChecking,
	selectMapHasChecked,
	selectMapHasUserData,
	selectMapErrorMessages,
	
	selectIsChecking,
	selectHasChecked,
	selectHasUserData,
	selectErrorMessages,
};
